import { render, staticRenderFns } from "./form_set_control.vue?vue&type=template&id=12882718&scoped=true&"
import script from "./form_set_control.vue?vue&type=script&lang=js&"
export * from "./form_set_control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12882718",
  null
  
)

export default component.exports